import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import $events from 'wee-events';
import $location from 'wee-location';
import qs from 'query-string';
import Tweezer from 'tweezer.js';
import { $serialize } from 'core/types';
import { _win } from 'core/variables';
import { expanded } from '../../../scripts/classes';

class Question {
    constructor(el) {
        this.$el = $(el);
        this.$answer = $(':answer', this.$el);
        this.$button = $(':toggle', this.$el);
        this.expanded = false;
        this.question = this.$el.data('question');

        $events.on(el, 'click', () => {
            this.operate();
        });
    }

    operate() {
        this.expanded = ! this.expanded;

        this.$el
            .ariaExpand(this.expanded)[this.expanded ? 'addClass' : 'removeClass'](expanded);
        this.$answer[this.expanded ? 'show' : 'hide']();
        this.$button.aria('label', this.expanded ? 'Close answer' : 'Expand to view answer');

        this.processQuery();
    }

    processQuery() {
        let query = qs.parse($location.uri().search);

        if (this.expanded) {
            query = {
                ...query,
                question: this.question,
            };
        } else {
            delete query.question;
        }

        _win.history.replaceState(null, null, `/faq?${$serialize(query)}`);
    }
}

class FaqList {
    constructor() {
        this.$list = $(':faqList');
        this.$questions = $(':question');
        this.category = $location.uri().query.category;
        this.question = $location.uri().query.question;
        this.questions = {};

        this.$questions.each((question) => {
            this.questions[$(question).data('question')] = new Question(question);
        });
    }
}

export default new RouteHandler({
    init() {
        const list = new FaqList();
        const query = qs.parse($location.uri().search);

        if (query.question) {
            const question = list.questions[query.question];

            if (question) {
                question.operate();

                new Tweezer({
                    start: $(_win).scrollTop(),
                    end: question.$el.offset().top,
                    duration: 500,
                }).on('tick', (value) => {
                    _win.requestAnimationFrame(() => _win.scrollTo(0, value));
                }).begin();
            }
        }
    },
});
